import { atomFamily } from 'recoil';

export const makeAPIPayload = atomFamily<any, any>({
  key: 'makeAPIPayload', // unique ID (with respect to other atoms/selectors)
  default: null,
  // default value (aka initial value)
});
